'use client';

import { useState, useRef } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Label,
} from 'reactstrap';
// Import Icons
import FeatherIcon from 'feather-icons-react';
import HCaptcha from '@hcaptcha/react-hcaptcha';

// Import services
import { sendContactMessage } from '../../services/users.service';

function ContactForm() {
  const [Contactvisible, setContactvisible] = useState(false);
  const [captchaToken, setCaptchaToken] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const captchaRef = useRef(null);
  const formStartTime = useRef(null);

  const handleFormFocus = () => {
    if (!formStartTime.current) {
      formStartTime.current = Date.now();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Honeypot check - bots usually fill all fields including hidden ones
    const honeypotField = e.target['wincc-type'];
    if (honeypotField && honeypotField.value) {
      console.log('Bot detected via honeypot field');
      return; // Silent fail for bots
    }

    // Time-based check - form must be filled in at least 3 seconds
    const timeTaken = Date.now() - (formStartTime.current || Date.now());
    if (timeTaken < 3000) {
      console.log('Bot detected via time check:', timeTaken, 'ms');
      return; // Silent fail for bots
    }

    // hCaptcha must be solved before sending.
    if (!captchaToken) {
      setCaptchaError('Please complete the captcha');
      return;
    }
    setCaptchaError('');

    setContactvisible(true);

    const name = e.target.name.value;
    const email = e.target.email.value;
    const subject = e.target.subject.value;
    const message = e.target.comments.value;
    sendContactMessage(name, email, subject, message, captchaToken);
    // Token is single-use — reset so a second message requires a fresh solve.
    captchaRef.current?.resetCaptcha();
    setCaptchaToken('');
  };

  return (
    <Form
      onSubmit={handleSubmit}
      name="contact-form"
      id="contact-form"
      onFocus={handleFormFocus}
    >
      {/* Honeypot field - hidden from users but visible to bots */}
      <input
        type="text"
        name="wincc-type"
        style={{
          position: 'absolute',
          left: '-5000px',
          top: '-5000px',
          visibility: 'hidden',
          pointerEvents: 'none',
        }}
        tabIndex="-1"
        autoComplete="off"
        aria-hidden="true"
      />

      <Row>
        <Col md={6}>
          <div className="mb-3">
            <Label className="form-label">
              Your Name
              {' '}
              <span className="text-danger">*</span>
            </Label>
            <div className="form-icon position-relative">
              <i>
                <FeatherIcon
                  icon="user"
                  className="fea icon-sm icons"
                />
              </i>
            </div>
            <Input
              name="name"
              id="name"
              type="text"
              className="form-control ps-5"
              placeholder="First Name :"
              required
            />
          </div>
        </Col>
        <Col md={6}>
          <div className="mb-3">
            <Label className="form-label">
              Your Email
              {' '}
              <span className="text-danger">*</span>
            </Label>
            <div className="form-icon position-relative">
              <i>
                <FeatherIcon
                  icon="mail"
                  className="fea icon-sm icons"
                />
              </i>
            </div>
            <Input
              name="email"
              id="email"
              type="email"
              className="form-control ps-5"
              placeholder="Your email :"
              required
            />
          </div>
        </Col>
        <Col md={12}>
          <div className="mb-3">
            <Label className="form-label">Subject</Label>
            <div className="form-icon position-relative">
              <i>
                <FeatherIcon
                  icon="book"
                  className="fea icon-sm icons"
                />
              </i>
            </div>
            <Input
              name="subject"
              id="subject"
              className="form-control ps-5"
              placeholder="Your subject :"
              required
            />
          </div>
        </Col>
        <Col md={12}>
          <div className="mb-3">
            <Label className="form-label">Comments</Label>
            <div className="form-icon position-relative">
              <i>
                <FeatherIcon
                  icon="message-circle"
                  className="fea icon-sm icons"
                />
              </i>
            </div>
            <textarea
              name="comments"
              id="comments"
              rows="4"
              className="form-control ps-5"
              placeholder="Your Message :"
            />
          </div>
        </Col>
      </Row>
      {!Contactvisible && (
        <Row>
          <Col sm={12} className="d-flex flex-column align-items-center mb-3">
            <HCaptcha
              ref={captchaRef}
              sitekey={process.env.NEXT_PUBLIC_HCAPTCHA_SITEKEY}
              onVerify={(token) => { setCaptchaToken(token); setCaptchaError(''); }}
              onExpire={() => setCaptchaToken('')}
              onError={() => setCaptchaToken('')}
            />
            {captchaError ? <small className="text-danger mt-2">{captchaError}</small> : null}
          </Col>
        </Row>
      )}
      <Row>
        <Col sm={12} className="text-center">
          <div className="d-grid">
            {Contactvisible ? (
              <div className="alert alert-success" role="alert">
                Contact details send successfully.
              </div>
            ) : (
              <input
                type="submit"
                id="submit"
                name="send"
                className="submitBnt btn btn-primary"
                value="Send Message"
              />
            )}
          </div>
          <div id="simple-msg" />
        </Col>
      </Row>
    </Form>
  );
}

export default ContactForm;
